// Module
var code = `<div class="btn-group schema-form-actions {{form.htmlClass}}" ng-transclude></div>
`;
// Exports
module.exports = code;